import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registered-webinars',
  templateUrl: './registered-webinars.component.html',
  styleUrls: ['./registered-webinars.component.scss']
})
export class RegisteredWebinarsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
